const LoadCSSforfirstTime = (path) => {
  // We use dynamic imports so the local React build system (sass)
  // can compile the SCSS files.
  // We are importing renamed .scss files (not .module.scss) 
  // to ensure styles apply GLOBALLY, matching the Cloud behavior.

  if (path.includes("FindWork.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/FindWork.scss");
  } else if (path.includes("FirstTimeUsers.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/FirstTimeUsers.scss");
  } else if (path.includes("app.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/app.scss");
  } else if (path.includes("chat.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/chat.scss");
  } else if (path.includes("contactus.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/contactus.scss");
  } else if (path.includes("dashboard.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/dashboard.scss");
  } else if (path.includes("download.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/download.scss");
  } else if (path.includes("expertregisteration.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/expertregisteration.scss");
  } else if (path.includes("footer.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/footer.scss");
  } else if (path.includes("header.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/header.scss");
  } else if (path.includes("hireexpert.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/hireexpert.scss");
  } else if (path.includes("homepage.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/homepage.scss");
  } else if (path.includes("membership.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/membership.scss");
  } else if (path.includes("myorders.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/myorders.scss");
  } else if (path.includes("payment.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/payment.scss");
  } else if (path.includes("postproject.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/postproject.scss");
  } else if (path.includes("searchcontestparticipate.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/searchcontestparticipate.scss");
  } else if (path.includes("searchdownloadcv.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/searchdownloadcv.scss");
  } else if (path.includes("umbrella.module.scss")) {
    import("../urxpert_gowtham/Assets/scss/umbrella.scss");
  }

  return null;
};

export default LoadCSSforfirstTime;